/*
 * reveal-timing.js -- sdilene konstanty triggeru reveal animaci (nalez
 * majitele 7. 9. "plocha zustane bez obsahu", schvalena odchylka, AS
 * DOPLNEK).
 *
 * Dva nezavisle reveal moduly na strance -- `hp2026.js` (homepage mockup,
 * trida `.in`) a `reveal.js` (sitewide komponentova knihovna, atribut
 * `data-reveal-ready`) -- driv drzely vlastni kopie IO prahu a odsazeni.
 * Tenhle soubor je sjednocuje na jedno misto, aby dalsi zmena rychlosti
 * triggeru nevyzadovala hledat dve mista se stejnym cislem.
 *
 * Casova delka animaci (duration/delay) zustava v CSS jako tokeny
 * `--reveal-dur-*`/`--reveal-delay-step` (tokens.css) -- tenhle modul resi
 * jen KDY se trigger spusti, ne jak dlouho bezi.
 */

/**
 * Podil prvku ve vyrezu, pri kterem IntersectionObserver zafiruje.
 *
 * AS2 (nalez majitele 7. 9., 2. kolo): 0.1 byl DRUHY skutecny bug --
 * `.revgrid` na /reference/ pri 390px (masonry `columns` kolabuje na
 * 1 sloupec) je vysoka ~14000px. Viewport 900px / cil 14000px = ~6,4 %,
 * takze prah 10 % nemohl zafirovat NIKDY -- sekce cekala vzdy jen na
 * 1,2s fallback v reveal.js, bez ohledu na scroll (overeno scratch
 * testem: `data-reveal-ready` zustavalo `null` i 550 ms po scrollu na
 * stred elementu). 0.01 stavi spusteni jen na PRUNIKU (pixel staci),
 * ne na pomeru plochy k celkove vysce cile -- funguje i pro velmi
 * vysoke sekce.
 */
export const REVEAL_IO_THRESHOLD = 0.01;

/**
 * Rozsireni korenu IO smerem k dolnimu okraji viewportu, aby se sekce
 * odhalila DRIV, nez fyzicky vstoupi do viewportu (AS2, nalez majitele
 * 7. 9., 2. kolo -- "porad pomaly efekt nabehu" i po prvni oprave).
 *
 * OPRAVA ZNAMENKA (byl to skutecny bug, ne jen doladeni): puvodni AS
 * hodnota `-10%` korenu ZUZOVALA (zaporny rootMargin zmensuje efektivni
 * hranici root elementu), takze sekce vstupujici zdola musela sjet o 10 %
 * vysky viewportu VIC, nez zacala protinat -- spoustela se POZDEJI, presny
 * opak zamerena "trigger driv". Overeno empiricky (scratch test, AS2):
 * zaporna hodnota `-10%` spustila IO pri o ~80px vetsim scrollu nez zadny
 * rootMargin; kladna hodnota `+20%` o ~140px driv. Kladny rootMargin
 * ROZSIRUJE root za viditelnou oblast, takze prvek pod ohybem stranky uz
 * "protina" zvetseny koren, i kdyz jeste neni fyzicky videt -- to je
 * spravny smer pro "odhal driv".
 */
export const REVEAL_ROOT_MARGIN = '0px 0px 20% 0px';

/** Jednotny fallback pro pripad, ze IO na prvek nikdy nezafiruje. */
export const REVEAL_FALLBACK_MS = 1200;
